// extracted by mini-css-extract-plugin
export default {"page":"NZ-z","cartModal":"OZ-z","checkout":"PZ-z","placeholder":"QZ-z","account":"RZ-z"};